export let VALIDATION_RULES = {
  required: value => !!value || "Required",
  //counter: value => value.length <= 20 || "Max 20 characters",
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)*[a-zA-Z]{2,}))$/;
    // const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|([a-zA-Z]{2,}))$/;
    return pattern.test(value) || "Invalid email";
  },
  phone: value => {
    return (
      (value &&
        value.match(/\d/g) &&
        value.match(/\d/g).length >= 10 &&
        /^\d+$/.test(value.charAt(value.length - 1))) ||
      "Invalid phone number"
    );
  },
  zip: value => {
    // eslint-disable-next-line no-useless-escape
    const pattern = /^(\d{5}(?:\-\d{4})?)$/;
    return pattern.test(value) || "Invalid ZIP";
  },
  number: value => {
    // eslint-disable-next-line no-useless-escape
    const pattern = /^(\d+)$/;
    return pattern.test(value) || "Invalid number";
  },
  phonekeypad: value => {
    // eslint-disable-next-line no-useless-escape
    const pattern = /^(\d|\*|#)+$/;
    return pattern.test(value) || "Invalid phone key combination";
  },
  words: value => {
    // eslint-disable-next-line no-useless-escape
    const pattern = /^(\w|\s|,)+$/;
    return pattern.test(value) || "Invalid word";
  }
};
